import { render } from "./Modal-mask.vue?vue&type=template&id=39432c14&scoped=true"
import script from "./Modal-mask.vue?vue&type=script&lang=js"
export * from "./Modal-mask.vue?vue&type=script&lang=js"

import "./Modal-mask.vue?vue&type=style&index=0&id=39432c14&lang=sass&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39432c14"]])

export default __exports__